import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import {
  NavigationUnreadCount,
  NavigationUnreadResponse,
} from '@zipari/shared-ds-util-navigation';

import { of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';

import { cloneObject } from '../../../shared/utils/object';

import * as actions from './ngrx-navigation.actions';

@Injectable()
export class NgrxNavigationEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
  ) {}

  unreadCountEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getUnreadCountInit.type),
      map((action: any) => action.payload),
      flatMap((payload: NavigationUnreadCount) =>
        this.http.get(payload.endpoint).pipe(
          map((response: NavigationUnreadResponse) =>
            actions.getUnreadCountSuccess({
              payload: {
                response,
                index: payload.index,
              },
            }),
          ),
          catchError(() => of({ type: actions.getUnreadCountError.type })),
        ),
      ),
    ),
  );

  createIconCountMap = (payload) => {
    const iconCountMap: any = {};

    payload.forEach((icon) => {
      !iconCountMap[icon.key]
        ? (iconCountMap[icon.key] = this.http.get(icon.count_api))
        : null;
    });

    return iconCountMap;
  };

  updateNavbarIconState = (countResponseAndIconState) => {
    const iconUnreadCounts: any = countResponseAndIconState[0];
    const icons: any = cloneObject(countResponseAndIconState[1]);

    icons.forEach((icon: any) => {
      Object.prototype.hasOwnProperty.call(iconUnreadCounts, icon.key)
        ? (icon.count = iconUnreadCounts[icon.key].unread_count)
        : (icon.count = null);
    });

    return { type: actions.getUnreadCountSuccess.type, payload: icons };
  };
}
